import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OfferBanner from '../../../../../stories/components/cars/homepage/OfferBanner/OfferBanner';
import GoSafeBanner from '../../../../../stories/components/cars/homepage/GoSafeBanner/GoSafeBanner';
import { fetchHomePageOffers } from '../../redux/thunks';
import { offerSelector, persuasionSelector , topCarouselSelector} from '../../redux/selector';
import CabFeatureCard from '../../../../../stories/components/cars/homepage/CabFeatureCard/CabFeatureCard';
import { getLoadedComponent } from '../../../../../shared/config/omni';

const HomeBanner = () => {
  const dispatch = useDispatch();
  const offersData = useSelector(offerSelector);
  const persuasion = useSelector(persuasionSelector);
  const bannerData = useSelector(topCarouselSelector);
  useEffect(() => {
    dispatch(fetchHomePageOffers());
    getLoadedComponent('Homebanner')
  }, []);
  return (
    <React.Fragment>
      <GoSafeBanner bannerData={bannerData} />
      <OfferBanner offersData={offersData} />
      <CabFeatureCard persuasion={persuasion} />
    </React.Fragment>
  );
}

export default HomeBanner;